import axios from 'axios';
import qs from 'qs';
import storageUtils from '../utils/storageUtils';

const CancelToken = axios.CancelToken
let sources = []
let removeSource = (config) => {
    for (let source in sources) {
        // 当多次请求相同时，取消之前的请求
        if (sources[source].umet === config.url + '&' + config.method) {
            sources[source].cancel("取消请求")
            sources.splice(source, 1)
        }
    }
}

// 请求响应
axios.interceptors.request.use(config => {
    let url = config.url.split('/');
    let method = url[url.length - 1]
    if (method !== 'g_single_translation' && method !== 's_one_third_party_app_trans' && method !== 's_lan_auto_sync_trans') {
        removeSource(config)
        config.cancelToken = new CancelToken((c) => {
            // 将取消函数存起来
            sources.push({ umet: config.url + '&' + config.method, cancel: c })
        })
    }
    return config
}, error => {
    return Promise.reject(error)
})

// 结果响应
axios.interceptors.response.use(response => {
    // 请求结束后将对应存储的取消函数删除
    removeSource(response.config)
    return response
}, error => {
    return Promise.reject(error)
})

export default function ajax(url, data = {}, type = 'GET', headers = "false") {
    return new Promise((resolve, reject) => {
        const token = storageUtils.get('NASadminToken') || ''
        const defaultHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        if (token) {
            defaultHeaders['Authorization'] = `Bearer ${token}`
        }
        let finalHeaders = defaultHeaders
        if (headers && typeof headers === 'object') {
            finalHeaders = { ...defaultHeaders, ...headers }
        } else if (headers === 'json') {
            // 特殊值：发送 JSON
            finalHeaders['Content-Type'] = 'application/json'
        }
        let request

        // GET 请求
        if (type.toUpperCase() === 'GET') {
            request = axios.get(url, {
                params: data,
                headers: finalHeaders
            })
        }
        // POST 请求
        else if (type.toUpperCase() === 'POST') {
            if (headers === 'json') {
                request = axios.post(url, data, { headers: finalHeaders })
            } else {
                // 普通 form 提交
                request = axios.post(url, qs.stringify(data), { headers: finalHeaders })
            }
        }

        // 执行请求
        request
            .then(response => {
                if(response.data.status === 404) window.location.href = '/login'
                resolve(response.data)
            })
            .catch(error => {
                // 可统一处理 401、403 等
                if (error.response?.status === 401) {
                    // token 失效，跳转登录
                    localStorage.removeItem('NASadminToken')
                    window.location.href = '/login'
                }
                reject(error)
            })
    })
}
